import { useContext, useState } from 'react'
import BlockContent from '@sanity/block-content-to-react'

import { SanityProductVariantFragment } from '@data/sanity/queries/types/product'
import { CartContext } from '@lib/cart'
import { serializers } from '@lib/serializers'
import { StringsContext } from '@lib/strings'

import Alert from '@components/alert'
import ProductWaitlist from './product-waitlist'
import ProductCounter from './product-counter'
import ProductAdd from './product-add'
import { ButtonVariant } from '@components/buttons/button'

interface ProductActionsProps {
  activeVariant: SanityProductVariantFragment
}

const ProductActions = ({ activeVariant }: ProductActionsProps) => {
  const strings = useContext(StringsContext)
  const { addItemsToCart } = useContext(CartContext)

  const [quantity, setQuantity] = useState(1)
  const [isAddToCartError, setIsAddToCartError] = useState(false)

  const handleAddToCart = async () => {
    setIsAddToCartError(false)

    const isSuccessful = await addItemsToCart([
      { id: activeVariant.id, quantity },
    ])

    setIsAddToCartError(!isSuccessful)
  }

  if (!activeVariant.inStock) {
    return <ProductWaitlist variantId={activeVariant.id} />
  }

  return (
    <div className="flex flex-col items-baseline w-full text-center">
      <ProductCounter
        id={`${activeVariant.id}`}
        max={10}
        onUpdate={setQuantity}
        className="mb-4"
      />

      <ProductAdd
        variant={ButtonVariant.PRIMARY}
        className="min-w-[240px]"
        onClick={handleAddToCart}
      >
        {strings.buttonAddToCart}
      </ProductAdd>

      {isAddToCartError && (
        <div key="error" className="mt-8">
          <Alert error>
            <BlockContent
              renderContainerOnSingleChild
              className="rc rc-error"
              blocks={strings.cartAddToCartErrorMessage}
              serializers={serializers}
            />
          </Alert>
        </div>
      )}
    </div>
  )
}

export default ProductActions
